import { useState } from "react";
import { DataTable } from "../../components/organisms/DataTable";
import { paginacion } from "../../utils/paginacion/paginacion";
import { CongeladoCard } from "./CongeladoCard";

const CONGELADOS_POR_PAGINA = 15;

export const CongeladoList = ({ congelados = [], onDelete }) => {
  const [paginaActual, setPaginaActual] = useState(1);

  const {
    objetosEnPagina: congeladosEnPagina,
    paginas,
    paginaInicial,
    paginaFinal,
  } = paginacion(paginaActual, congelados, CONGELADOS_POR_PAGINA);

  const columnas = [
    "#",
    "Nombre",
    "Apellido",
    "Teléfono",
    "Tipo de Admisión",
    "Programa",
    "Grupo",
    "Módulo",
    "Tipo de Congelado",
    "Fecha de Congelado",
  ];

  const mostrarCongelados = congeladosEnPagina?.length > 0;

  return (
    <DataTable
      columnas={columnas}
      paginas={paginas}
      paginaInicial={paginaInicial}
      paginaFinal={paginaFinal}
      paginaActual={paginaActual}
      setPaginaActual={setPaginaActual}
    >
      {mostrarCongelados ? (
        congeladosEnPagina.map((congelado, i) => (
          <CongeladoCard
            key={congelado?.estudiante?.idEstudiante || i}
            estudiante={congelado}
            index={(paginaActual - 1) * CONGELADOS_POR_PAGINA + i}
            onDelete={onDelete}
          />
        ))
      ) : (
        <tr>
          <td colSpan={columnas.length} className="text-center py-4">
            No hay estudiantes congelados
          </td>
        </tr>
      )}
    </DataTable>
  );
};
